/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-04 15:14:38
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { stringifyRGBA } from 'src/helpers/color-helper';

type Props = {
  settings: Object
};

type ComposedProps = Props & WithI18nProps;

class PreviewMobileButton extends Component<ComposedProps, State> {
  render() {
    const { settings, i18n } = this.props;

    let {
      filterMobileButtonBackgroundColor,
      filterMobileButtonFontFamily,
      filterMobileButtonFontSize,
      filterMobileButtonFontTransform,
      filterMobileButtonFontWeight,
      filterMobileButtonTextColor
    } = settings;

    filterMobileButtonBackgroundColor = this.parseColor(filterMobileButtonBackgroundColor);
    filterMobileButtonTextColor = this.parseColor(filterMobileButtonTextColor);

    const filterMobileButtonStyle = {
      color: filterMobileButtonTextColor,
      backgroundColor: filterMobileButtonBackgroundColor,
      fontSize: filterMobileButtonFontSize ? parseInt(filterMobileButtonFontSize) : 'initial',
      textTransform: filterMobileButtonFontTransform,
      fontFamily: filterMobileButtonFontFamily,
      fontWeight: filterMobileButtonFontWeight ? parseInt(filterMobileButtonFontWeight) : 'initial'
    };

    return (
      <div className="mobileButton">
        <button style={filterMobileButtonStyle}>
          {i18n.translate('AdminHTML.FilterSettings.Style.previewMobileButton_ButtonChildren')}
        </button>
      </div>
    );
  }

  // Parse color from HSV or from string to RGBA
  parseColor(color) {
    if (_.has(color, 'rgb')) {
      color = stringifyRGBA(color.rgb);
    } else if (_.isString(color)) {
      color = color.replace(/\|\|/g, ', ');
    }

    return color;
  }
}

export default withI18n()(PreviewMobileButton);
